import { useEffect, useState } from 'react'
import { useProduct } from '../../../../hooks/useProduct'
import { PRODUCT_NOT_FOUND_ERROR } from './errors'

export const useToProduct = (productId: string | number | null) => {
  const { product, error: productError, isLoading } = useProduct(productId)
  const [errorCode, setErrorCode] = useState<string | undefined>()
  const [error, setError] = useState<any>()

  useEffect(() => {
    setErrorCode(undefined)

    if (productError?.response?.status === 404) {
      setErrorCode(PRODUCT_NOT_FOUND_ERROR)
      setError(productError)
    }
  }, [productError])

  return {
    product,
    error,
    isLoading,
    errorCode,
  }
}
